import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Blog } from "./components/blog";
import { FAQ } from "./components/faq";
// import { CaseStudy } from "./components/caseStudy";
// import { Testimonials } from "./components/testimonials";
import { Contact } from "./components/contact";
import { BlogDetail } from "./components/BlogDetail";
import { BlogList } from "./components/BlogList";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"; 
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// Ana sayfa bileşeni
const HomePage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Helmet>
        {/* Ana Sayfa SEO - Google ve Microsoft Bing Optimizasyonu */}
        <title>TR Assist - Türkiye'nin Önde Gelen Yol Yardım ve İkame Araç Hizmetleri | 7/24 Profesyonel Destek</title>
        <meta name="description" content="TR Assist, Türkiye'de kurumsal firmalara ve sigorta şirketlerine 7/24 profesyonel yol yardım ve ikame araç hizmetleri sunar. 81 ilde geniş hizmet ağı, ISO sertifikalı kalite, hızlı müdahale süreleri. Güvenilir, hızlı ve kaliteli çözümlerle yanınızdayız." />
        <meta name="keywords" content="yol yardım, ikame araç, sigorta şirketleri, kurumsal yol yardım, araç kurtarma, lastik patlaması, akü bitmesi, Türkiye yol yardım, 7/24 yol yardım, yol yardım hizmeti, araç çekici, acil yol yardım, filo yönetimi, sigorta asistans, kurumsal asistans, ISO sertifikalı yol yardım, 81 ilde yol yardım, profesyonel yol yardım, hızlı müdahale, çağrı merkezi entegrasyonu, dijital yol yardım, teknolojik yol yardım çözümleri" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="language" content="Turkish" />
        <meta name="author" content="TR Assist" />
        <meta name="geo.region" content="TR-34" />
        <meta name="geo.placename" content="İstanbul" />
        <meta name="geo.position" content="41.0082;28.9784" />
        <meta name="ICBM" content="41.0082, 28.9784" />
        <meta name="revisit-after" content="1 days" />
        <meta name="rating" content="general" />
        
        {/* Microsoft Bing Meta Tags */}
        <meta name="msvalidate.01" content="" />
        <meta name="msapplication-TileColor" content="#0066cc" />
        <meta name="msapplication-config" content="/browserconfig.xml" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://www.trassist.com.tr" />
        <link rel="alternate" hreflang="tr" href="https://www.trassist.com.tr" />
        <link rel="alternate" hreflang="x-default" href="https://www.trassist.com.tr" />
        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="TR Assist - Türkiye'nin Önde Gelen Yol Yardım ve İkame Araç Hizmetleri" />
        <meta property="og:description" content="Türkiye'de kurumsal firmalara ve sigorta şirketlerine 7/24 profesyonel yol yardım ve ikame araç hizmetleri sunuyoruz. 81 ilde geniş hizmet ağı, ISO sertifikalı kalite." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.trassist.com.tr" />
        <meta property="og:image" content="https://www.trassist.com.tr/img/tr_assistance_logo.svg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="TR Assist - Profesyonel Yol Yardım Hizmetleri" />
        <meta property="og:site_name" content="TR Assist" />
        <meta property="og:locale" content="tr_TR" />
        <meta property="og:locale:alternate" content="en_US" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="TR Assist - Profesyonel Yol Yardım Hizmetleri" />
        <meta name="twitter:description" content="Türkiye'de kurumsal firmalara ve sigorta şirketlerine 7/24 profesyonel yol yardım ve ikame araç hizmetleri sunuyoruz." />
        <meta name="twitter:image" content="https://www.trassist.com.tr/img/tr_assistance_logo.svg" />
        <meta name="twitter:image:alt" content="TR Assist Logo" />
        <meta name="twitter:site" content="@trassist" />
        <meta name="twitter:creator" content="@trassist" />
        
        {/* Structured Data - Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "TR Assist",
            "alternateName": "TR Assistance",
            "description": "Türkiye'de kurumsal firmalara ve sigorta şirketlerine profesyonel yol yardım ve ikame araç hizmetleri sunan önde gelen şirket",
            "url": "https://www.trassist.com.tr",
            "logo": "https://www.trassist.com.tr/img/tr_assistance_logo.svg",
            "image": "https://www.trassist.com.tr/img/tr_assistance_logo.svg",
            "telephone": "+90-850-335-09-97",
            "email": "info@trassist.com.tr",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+90-850-335-09-97",
              "contactType": "customer service",
              "availableLanguage": ["Turkish"],
              "areaServed": "TR",
              "hoursAvailable": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                "opens": "00:00",
                "closes": "23:59"
              }
            },
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "TR",
              "addressLocality": "İstanbul",
              "addressRegion": "İstanbul"
            },
            "sameAs": [
              "https://www.instagram.com/tr.assistance/"
            ],
            "serviceArea": {
              "@type": "Country",
              "name": "Turkey"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Yol Yardım Hizmetleri",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Yol Yardım Hizmetleri",
                    "description": "Araç arızası, lastik patlaması, akü bitmesi gibi tüm yol yardım ihtiyaçlarınızda profesyonel teknik ekibimizle hızlı çözüm",
                    "provider": {
                      "@type": "Organization",
                      "name": "TR Assist"
                    },
                    "areaServed": {
                      "@type": "Country",
                      "name": "Turkey"
                    },
                    "serviceType": "Yol Yardım"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "İkame Araç Hizmeti",
                    "description": "Aracınızın uzun süreli tamir gerektirdiği durumlarda, geçici ikame araç temin ederek işlerinizin aksamasını önleme",
                    "provider": {
                      "@type": "Organization",
                      "name": "TR Assist"
                    },
                    "areaServed": {
                      "@type": "Country",
                      "name": "Turkey"
                    },
                    "serviceType": "İkame Araç"
                  }
                }
              ]
            }
          })}
        </script>
        
        {/* Structured Data - LocalBusiness */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "@id": "https://www.trassist.com.tr",
            "name": "TR Assist",
            "image": "https://www.trassist.com.tr/img/tr_assistance_logo.svg",
            "telephone": "+90-850-335-09-97",
            "email": "info@trassist.com.tr",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "İstanbul",
              "addressRegion": "İstanbul",
              "addressCountry": "TR"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 41.0082,
              "longitude": 28.9784
            },
            "url": "https://www.trassist.com.tr",
            "priceRange": "$$",
            "openingHoursSpecification": {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
              "opens": "00:00",
              "closes": "23:59"
            },
            "areaServed": {
              "@type": "Country",
              "name": "Turkey"
            }
          })}
        </script>
        
        {/* Structured Data - FAQPage */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": (JsonData.FAQ || []).slice(0, 5).map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })}
        </script>
      </Helmet>
      
      <Navigation />
      <Header data={landingPageData.Header} slides={landingPageData.HeroSlides} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      {/* {landingPageData?.PromoSlides && (
        <section id="promo-slider" className="container" style={{ margin: "40px auto" }}>
          <TRSlider items={landingPageData.PromoSlides} fade={true} autoplay={true} dots={true} arrows={false} />
        </section>
      )} */}
      <Blog data={landingPageData.Blog} />
      <FAQ data={landingPageData.FAQ} />
      {/* <CaseStudy data={landingPageData.CaseStudy} /> */}
      {/* <Testimonials data={landingPageData.Testimonials} /> */}
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

// Blog detay sayfası için veri hazırlama fonksiyonu
const getBlogData = (slug) => {
  // Blog listesinden ilgili blog'u bul
  const blogList = JsonData.Blog || [];
  const blog = blogList.find(b => b.slug === slug);
  
  if (!blog) return null;
  
  // Blog detayını al
  const blogDetails = JsonData.BlogDetails || {};
  const detail = blogDetails[slug];
  
  // Blog verisi ve detayını birleştir
  return {
    ...blog,
    content: detail ? detail.content : null
  };
};

// Navigation ile birlikte blog detay sayfası
const BlogDetailPage = () => {
  const { slug } = useParams();
  const data = getBlogData(slug);
  return (
    <>
      <Navigation />
      <BlogDetail blogData={data} allBlogs={JsonData.Blog || []} />
    </>
  );
};

// Tüm bloglar sayfası
const BlogListPage = () => {
  return (
    <>
      <Navigation />
      <BlogList blogs={JsonData.Blog || []} />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blogs" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
      </Routes>
    </Router>
  );
};

export default App;
